import { createIntl, createIntlCache } from 'react-intl';

import arMessages from '../compiled-locale/ar.json';
import deMessages from '../compiled-locale/de.json';
import elMessages from '../compiled-locale/el.json';
import enMessages from '../compiled-locale/en-GB.json';
import frMessages from '../compiled-locale/fr.json';
import idMessages from '../compiled-locale/id.json';
import msMessages from '../compiled-locale/ms.json';
import nlMessages from '../compiled-locale/nl.json';

interface LanguageDict {
  //ESlint needs to be ignored for this interface due to translation keys
  [key: string]: any; // eslint-disable-line
}

const DEFAULT_FALLBACK_LANG = 'en';

const languageLines: LanguageDict = {
  en: enMessages,
  fr: frMessages,
  de: deMessages,
  nl: nlMessages,
  ar: arMessages,
  el: elMessages,
  id: idMessages,
  ms: msMessages,
};

const getCurrentLocale = () => {
  // Web Workers do not support local storage, and
  // this file is read by the worker to generate PDFs from react-pdf
  if (localStorage !== undefined) {
    const language = JSON.parse(localStorage.getItem('lang') ?? 'null');
    return language ? language.code : DEFAULT_FALLBACK_LANG;
  } else {
    return DEFAULT_FALLBACK_LANG;
  }
};

const cache = createIntlCache();

export const getCurrentIntl = () => {
  const locale = getCurrentLocale();
  const messages = languageLines[locale];
  const intl = createIntl(
    { locale, messages, defaultLocale: DEFAULT_FALLBACK_LANG },
    cache,
  );
  return intl;
};
